const DeclineCorporateEventIcon = () => {
	return (
		<svg width="28" height="25" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.375 20.749H4.46875C4.27813 20.749 4.09531 20.6733 3.96052 20.5385C3.82573 20.4037 3.75 20.2209 3.75 20.0303V12.124C3.75 10.9914 3.97309 9.8698 4.40654 8.82337C4.83998 7.77694 5.4753 6.82613 6.2762 6.02522C7.0771 5.22432 8.02791 4.58901 9.07435 4.15556C10.1208 3.72211 11.2423 3.49902 12.375 3.49902H12.375C13.5077 3.49902 14.6292 3.72212 15.6756 4.15556C16.7221 4.58901 17.6729 5.22432 18.4738 6.02523C19.2747 6.82613 19.91 7.77695 20.3435 8.82338C20.7769 9.86981 21 10.9914 21 12.124V12.124C21 14.4115 20.0913 16.6053 18.4738 18.2228C16.8563 19.8403 14.6625 20.749 12.375 20.749Z"
				stroke="#B42318"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle cx="20" cy="9.5" r="8" fill="white" />
			<path
				d="M22.9375 6.5625L15.0625 14.4375"
				stroke="#B42318"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22.9375 14.4375L15.0625 6.5625"
				stroke="#B42318"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default DeclineCorporateEventIcon;
